export function AdError(message) {
    Error.apply(this, arguments);
    this.message = message;
}
AdError.prototype = Object.create(Error.prototype);
AdError.prototype.constructor = AdError;

export const whitelistedPages = [
    "10peoplestyle",
    "401ok",
    "401okay",
    "5starhome",
    "BuzzFeedMarket",
    "Goodful",
    "abouttoeat",
    "asis",
    "bfafterdark",
    "bfbuymethat",
    "bientasty",
    "blackvoices",
    "bringme",
    "bringmeespanol",
    "buzzfeed",
    "buzzfeedanimal",
    "buzzfeedanimals",
    "buzzfeedapop",
    "buzzfeedbooks",
    "buzzfeedbrasil",
    "buzzfeedcanada",
    "buzzfeedceleb",
    "buzzfeedcommunity",
    "buzzfeeders",
    "buzzfeedfood",
    "buzzfeedgermany",
    "buzzfeedhealth",
    "buzzfeedindia",
    "buzzfeedjapan",
    "buzzfeedlatam",
    "buzzfeedlgbtq",
    "buzzfeedmexico",
    "buzzfeednews",
    "buzzfeednews_jp",
    "buzzfeednifty",
    "buzzfeednow",
    "buzzfeedoz",
    "buzzfeedpets",
    "buzzfeedphoto",
    "buzzfeedpuppies",
    "buzzfeedquiz",
    "buzzfeedreviews",
    "buzzfeedshopping",
    "buzzfeedstudios",
    "buzzfeedtasty",
    "buzzfeedtrending",
    "buzzfeeduk",
    "buzzfeedunsolved",
    "buzzfeedvideo",
    "buzzfeedworthit",
    "chikn.nuggit",
    "cocoabutter",
    "comics",
    "complex",
    "complexcanada",
    "complexmusic",
    "complexnews",
    "complexpop",
    "complexsneakers",
    "complexstyle",
    "ewwiloveit",
    "famouscrimescene",
    "faroutofficial",
    "firstwefeast",
    "founditforyou",
    "gadgets.gizmos",
    "goodful",
    "howtoraiseakid",
    "huffpost",
    "huffpostasianvoices",
    "huffpostindigenousvoices",
    "huffpostlife",
    "huffpostpolitics",
    "huffpostqueervoices",
    "huffpostrelationships",
    "huffposttaste",
    "huffpostuk",
    "huffpostwomen",
    "justgoodnews",
    "latinovoices",
    "migentebuzzfeed",
    "peopleofbuzzfeed",
    "perolike",
    "perolikeofficial",
    "ph_automation_dev",
    "pigsandplans",
    "proper_tasty",
    "pubhubstage",
    "reader",
    "seasonedbf",
    "shakybarista",
    "shopbuzzfeed",
    "singlegrrrl",
    "solecollector",
    "southcentraldad",
    "tasty",
    "tastyhome",
    "tastyhomeofficial",
    "tastyjapan",
    "tastyjunior",
    "tastylatam",
    "thegoodadvicecupcake",
    "thelandofboggs",
    "tiktoktest",
    "ultimateguypals",
    "weirdhelga",
    "wheresmysign",
    "world"
]

export const sizes = {
    PROGRAMMATIC_SMARTPHONE_BANNER: [320, 50],
    PROGRAMMATIC_MEDIUM_RECTANGLE: [300, 250],
};

export const programmaticSizes = Object.entries(sizes)
    .filter(([name]) => name.startsWith('PROGRAMMATIC'))
    .map(([, value]) => value);

export const config = {
    'promo-inline-1': {
        adPos: 'inline-1',
        wid: 210,
        size: [
            sizes.PROGRAMMATIC_SMARTPHONE_BANNER,
            sizes.PROGRAMMATIC_MEDIUM_RECTANGLE,
        ],
        noPrebid: true,
        zone1: 'bfd.bio',
        targeting: { pos: 'inline-1', wid: 210 },
    },
    'promo-inline-2': {
        adPos: 'inline-2',
        wid: 211,
        size: [
            sizes.PROGRAMMATIC_SMARTPHONE_BANNER,
            sizes.PROGRAMMATIC_MEDIUM_RECTANGLE,
        ],
        noPrebid: true,
        zone1: 'bfd.bio',
        targeting: { pos: 'inline-2', wid: 211 },
    },
    'promo-inline-3': {
        adPos: 'inline-3',
        wid: 212,
        size: [
            sizes.PROGRAMMATIC_SMARTPHONE_BANNER,
            sizes.PROGRAMMATIC_MEDIUM_RECTANGLE,
        ],
        noPrebid: true,
        zone1: 'bfd.bio',
        targeting: { pos: 'inline-3', wid: 212 },
    },
    'promo-inline-4': {
        adPos: 'inline-4',
        wid: 213,
        size: [
            sizes.PROGRAMMATIC_SMARTPHONE_BANNER,
            sizes.PROGRAMMATIC_MEDIUM_RECTANGLE,
        ],
        noPrebid: true,
        zone1: 'bfd.bio',
        targeting: { pos: 'inline-4', wid: 213 },
    },
    'promo-inline-5': {
        adPos: 'inline-5',
        wid: 214,
        size: [
            sizes.PROGRAMMATIC_SMARTPHONE_BANNER,
            sizes.PROGRAMMATIC_MEDIUM_RECTANGLE,
        ],
        noPrebid: true,
        zone1: 'bfd.bio',
        targeting: { pos: 'inline-5', wid: 214 },
    },
    'promo-inline-infinite': {
        adPos: 'inline-infinite',
        wid: 2100,
        size: [
            sizes.PROGRAMMATIC_SMARTPHONE_BANNER,
            sizes.PROGRAMMATIC_MEDIUM_RECTANGLE,
        ],
        noPrebid: true,
        zone1: 'bfd.bio',
        isInfinite: true,
        targeting: { pos: 'inline-infinite', wid: 2100 },
    },
};
